import { Box } from '@mui/material';
import { TextInput } from '../TextInput';
import PasswordStrengthBar from 'react-password-strength-bar';
import { onlyAllowAlphabet } from '../../helper';
import useShowPassword from '../../hooks/useShowPassword';

const FormRegister = ({ errors, isTouched = {
  email: undefined,
  first_name: undefined,
  password: undefined,
  password_confirm: undefined
}, formOnChange, values, setPasswordScore }) => {
  const { onShowPassword, showPassword } = useShowPassword({
    typePassword: 'password',
    typePasswordConfirm: 'password_confirm',
  });

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
      }}
    >
      <TextInput
        label="Nama"
        placeholder="Masukan Nama Anda"
        error={Boolean(values.first_name) && Boolean(errors.first_name)}
        error_msg={errors.first_name}
        value={values.first_name}
        onChange={formOnChange}
        onKeyPress={(e) => onlyAllowAlphabet(e)}
        name="first_name"
        type="text"
      />
      <TextInput
        label="Email"
        placeholder="Masukan Email Anda"
        error={Boolean(values.email)}
        error_msg={errors.email}
        value={values.email}
        onChange={formOnChange}
        name="email"
        type="email"
      />
      <TextInput
        label="Kata Sandi"
        placeholder="Masukan Kata Sandi"
        error={Boolean(values.password)}
        error_msg={errors.password}
        value={values.password}
        onChange={formOnChange}
        name="password"
        type="password"
        show={showPassword.password}
        onShow={onShowPassword}
      />
      {values.password.length > 0 && (
        <PasswordStrengthBar
          password={values.password}
          scoreWords={[
            'Peringatan! Kata sandi harus mengandung huruf besar,kecil dan angka',
            'Buruk',
            'Kurang baik',
            'Sangat baik',
            'Sempurna',
          ]}
          onChangeScore={(score) => {
            setPasswordScore((prev) => ({
              ...prev,
              password: score,
            }));
          }}
        />
      )}
      <TextInput
        label="Kata Sandi Konfirmasi"
        placeholder="Masukan Konfirmasi Kata Sandi"
        error={Boolean(values.password_confirm)}
        error_msg={errors.password_confirm}
        value={values.password_confirm}
        onChange={formOnChange}
        name="password_confirm"
        type="password"
        show={showPassword.password_confirm}
        onShow={onShowPassword}
      />
      {values.password_confirm.length > 0 ? (
        <PasswordStrengthBar
          password={values.password_confirm}
          scoreWords={[
            'Peringatan! Kata sandi harus mengandung huruf besar,kecil dan angka',
            'Buruk',
            'Kurang baik',
            'Sangat baik',
            'Sempurna',
          ]}
          onChangeScore={(score) => {
            setPasswordScore((prev) => ({
              ...prev,
              passwordConfirm: score,
            }));
          }}
        />
      ) : (
        <></>
      )}
    </Box>
  );
};

export default FormRegister;
